export default {
  set(data) {
    Object.keys(data).forEach(key => {
      this[key] = data[key];
    });
  }
};